module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/strikethrough.59937ef8.svg";